<template>
  <div class="uploadForm">
    <div class="title" v-if="showMoreTitle">申请材料</div>
    <div class="upload-table">
      <div class="row" v-for="(item,idx) in uploadList[keyAttachIder]"  :key="idx+keyAttachIder">
        <div class="titleNumber">{{keyAttachIder}}</div>
        <div class="content" v-if="showMoreTitle">
          {{item.Value}}
          <span style="color:red;">{{item.Required?'(必须上传)':''}}</span>
        </div>
        <div class="content">{{item.Remark}}</div>
        <div class="content">
          <upload
            @uploadSuccess="uploadSuccess"
            @removeFile="removeFile"
            :idx="idx"
            :configStr="item"
          ></upload>
          <a class="fileItem"  name="attachment-link" :home="'attachMentId='+keyAttachIder+'COM'+uploadList[keyAttachIder][0].AttachMentId" v-if="item.IsSuccess&&item.showLook" @click="showFile(item)">查看</a>
<!--          <a  class="fileItem"  @click="showFiles(item)">查看</a>-->
          <a
            class="attachment-link"
            name="attachment-link"

            v-if="item.IsSuccess&&!item.showLook"
            target="blanck"
            :home="'attachMentId='+keyAttachIder+'COM'+uploadList[keyAttachIder][0].AttachMentId"
            :href="encryptFileUrl(uploadList[keyAttachIder][0].AttachMentId)"
          >下载</a>
        </div>
      </div>
    </div>

    <el-dialog title="附件预览" :visible.sync="dialogVisible" width="800px">
      <div class="fileBox ub ub-ac ub-pc">
        <img :src="dialogImg" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="dialogVisible = false;dialogImg=''">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import Upload from '@/components/button/upload';
import { ImportantDocList } from '@/service/PropertyContractRecordController/ImportantDocList';
import { CommonControllerSvr } from '@/service/CommonControllerSvr/CommonControllerSvr';
import { mapState } from 'vuex';
import { devEnvironment, proEnvironment } from '@/assets/js/division';
import pdfPreview from '@/components/common/pdfPreview';
import { PublicInfoController } from '@/service/PublicInfoController/PublicInfoController.js';
import {aesEncrypt} from '@/utils/aes.js';
export default {
  components: { Upload,pdfPreview },
  props: {
    uploadList: Array, //需要上传的附件列表
    showTitle: Boolean,
    keyAttachId: Number,
    reportFormName: String,
  },
  data() {
    return {
      files:[],
      key:'',
      ifpdf:false,
      keyAttachIder: '',
      fileName:'',
      uploadData: [], //上传的附件集合
      dialogVisible: false,
      dialogImg: '',
      showMoreTitle: true,
      commonControllerSvr: new CommonControllerSvr(),
      time: true,
      aesEncrypt: aesEncrypt
      // fileListArr: [{AttachArr:[],IsSuccess:false,showLook: false, Key: "0101",MaxSize: "10MB",Mode: "upload",Remark: "支持PNG，JPEG，DOC、DOCX，XLS、XLSX，RAR、ZIP格式,不能超过10M。",Typeexts:"*.doc;*.docx;*.xls;*.xlsx;*.png;*.jpeg;*.jpg;*.zip;*.rar;",Require: true,Value: "相关材料"}],
    };
  },
  watch: {
    keyAttachIder (val) {
        if(this.reportFormName == '业务收支情况明细表') {
          this.uploadList[val] = [{AttachArr:[],IsSuccess:false,showLook: false, Key: "0101",MaxSize: "10MB",Mode: "upload",Remark: "您可以上传财务报表代替填写模板,支持PDF格式,不能超过10M。",Typeexts:"*.PDF;*.pdf",Require: true,Value: "相关材料"}]
          this.publicInfoController.getReprotFillDraft(this.token).then(res =>{
            let val = {
              AttachMentId : res.attachment,
              IsSuccess : Object.keys(res) == 0 || res.attachment == null ? false : true,
              KeyId: undefined,
              FileName:".pdf"
            }
            this.$store.commit('SET_REPROTFILLDRAFT',val)
            this.someMethod(val)
          }).catch(err =>{
            this.$message({
            type: 'error',
            message: err
          });
          })
        }else{
          this.uploadList[val] = [{AttachArr:[],IsSuccess:false,showLook: false, Key: "0101",MaxSize: "10MB",Mode: "upload",Remark: "支持PNG，JPEG，PDF，DOC、DOCX，XLS、XLSX，RAR、ZIP格式,不能超过10M。",Typeexts:"*.doc;*.docx;*.xls;*.xlsx;*.png;*.jpeg;*.jpg;*.zip;*.rar;*.pdf",Require: true,Value: "相关材料"}]
        }
    },
    uploadList: {
      handler(val) {}
        // if(!this.$route.query.bisKey) {

        // } else if (this.time) {
        //   this.time = false;
        //   this.commonControllerSvr
        //     .GetImportantDocList(this.token, this.$route.query.bisKey)
        //     .then(res => {
        //       this.uploadData = res._Items;
        //       if (this.uploadData.length > 0) {
        //         for (let i = 0; i < this.uploadList.length; i++) {
        //           for (let j = 0; j < res._Items.length; j++) {
        //             if (
        //               this.uploadList[i][0].Key === res._Items[j].DocumentValue
        //             ) {
        //               this.uploadList[i][0].IsSuccess = true;
        //               this.uploadList[i][0].KeyId = res._Items[j].KeyId;
        //               this.uploadList[i][0].AttachMentId =
        //                 res._Items[j].AttachMentId;
        //               if (
        //                 this.uploadList[i][0].Typeexts.indexOf('.jpg') >= 0 ||
        //                 this.uploadList[i][0].Typeexts.indexOf('.gif') >= 0 ||
        //                 this.uploadList[i][0].Typeexts.indexOf('.png') >= 0 ||
        //                 this.uploadList[i][0].Typeexts.indexOf('.jpeg') >= 0
        //               ) {
        //                 this.uploadList[i][0].showLook = true;
        //               } else {
        //                 this.uploadList[i][0].showLook = false;
        //               }
        //               this.uploadList.splice(i, 1, this.uploadList[i]);
        //               this.uploadData.splice(j, 1, res._Items[j]);
        //               break;
        //             }
        //           }
        //         }
        //         this.$emit(
        //           'getFileList',
        //           new ImportantDocList(this.uploadData),
        //           true
        //         );
        //       }
        //     });
        // }
      // }
    }
  },
  computed: {
    ...mapState(['token']),
    baseURL() {
      let baseURL = '';
      if (process.env.NODE_ENV === 'development') {
        baseURL = devEnvironment;
      } else if (process.env.NODE_ENV === 'production') {
        baseURL = 'szwyweb/';
      }
      return baseURL;
    },
    baseURLszwyweb(){
      let baseURLszwyweb = '';
      if (process.env.NODE_ENV === 'development') {
        baseURLszwyweb = devEnvironment;
      } else if (process.env.NODE_ENV === 'production') {
        baseURLszwyweb = proEnvironment;
      }
      return baseURLszwyweb;
    }
  },
  created() {
    this.keyAttachIder = this.keyAttachId;
    this.publicInfoController = new PublicInfoController();
  },
  mounted() {
    if (this.showTitle) {
      this.showMoreTitle = false
    }
  },
  methods: {
    // 加密后的文件路径
    encryptFileUrl(attachMentId) {
      const enAttachMentId = this.aesEncrypt(attachMentId);
      const strText = this.aesEncrypt(`${this.token},${attachMentId}`);
      const times = this.aesEncrypt(new Date().getTime().toString());
      const imgEnUrl = `${this.baseURL}importantDocByNewController.assx/checkImportantDoc?token=${this.token}&attachMentId=${enAttachMentId}&strText=${strText}&times=${times}`;
      return imgEnUrl;
    },
    async someMethod(val) {
      await this.uploadSuccess(val, 0); // 等待这个方法完成
      this.uploadList[this.keyAttachIder][0].IsSuccess = val.IsSuccess; // 然后执行这一行
    },
    close(){
      this.dialogVisible = false;
      // 后台临时文件删除
    },
    handleNodeClick(data) {
    },
    //上传成功回调
    uploadSuccess(val, idx) {
      if (
        val.FileName.indexOf('.jpg') >= 0 ||
        val.FileName.indexOf('.gif') >= 0 ||
        val.FileName.indexOf('.png') >= 0 ||
        val.FileName.indexOf('.jpeg') >= 0){
        this.uploadList[this.keyAttachIder][idx].showLook = true;
      }
      if(val.FileName.indexOf('.pdf') >= 0) {
        this.uploadList[this.keyAttachIder][idx].showLook = false;
      }
      this.uploadList[this.keyAttachIder][idx].IsSuccess = true;
      this.uploadList[this.keyAttachIder][idx].AttachMentId = val.AttachMentId;
      this.uploadList[this.keyAttachIder][idx].KeyId = val.KeyId;
      this.uploadList.splice(this.keyAttachIder, 1, this.uploadList[this.keyAttachIder]);
      this.uploadData.splice(this.keyAttachIder, 1, val);
      let requiredSuccess = true; //必传文件是否已上传
      for (let i = 0; i < this.uploadList.length; i++) {
        if (this.uploadList[i][0].Required) {
          if (this.uploadList[i][0].IsSuccess === undefined || null || false) {
            requiredSuccess = false;
            break;
          }
        }
      }
      if (requiredSuccess) {
        this.$emit('getFileList', new ImportantDocList(this.uploadData), true);
      } else {
        this.$emit('getFileList', new ImportantDocList(this.uploadData), false);
      }
    },
    //删除上传文件
    removeFile(val) {
      for (let i = 0; i < this.uploadData.length; i++) {
        if (this.uploadData[i].DocumentValue === val.Key) {
          this.uploadData.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < this.uploadList.length; i++) {
        if (val.Key === this.uploadList[i].Key) {
          this.uploadList[i].IsSuccess = false;
          this.uploadList.splice(i, 1, this.uploadList[i]);
          break;
        }
      }
      let requiredSuccess = true; //必传文件是否已上传
      for (let i = 0; i < this.uploadList.length; i++) {
        if (this.uploadList[i].Required) {
          if (this.uploadList[i].IsSuccess === undefined || null || false) {
            requiredSuccess = false;
            break;
          }
        }
      }
      this.$emit(
        'getFileList',
        new ImportantDocList(this.uploadData),
        requiredSuccess
      );
    },

    showFile(item) {
      this.dialogVisible = true;
      let idx;
      for (let i = 0; i < this.uploadData.length; i++) {
        if (item.Key === this.uploadData[i].DocumentValue) {
          idx = i;
          break;
        }
      }
      this.dialogImg = this.encryptFileUrl(item.AttachMentId);
    },
    showOneImag(item){
      let idx;
      for (let i = 0; i < this.uploadData.length; i++) {
        if (item.Key === this.uploadData[i].DocumentValue) {
          idx = i;
          break;
        }
      }
      var houzhui = item.split('.');
      var length = houzhui.length;
      if(houzhui[length-1]==='pdf' ||houzhui[length-1]==='doc' || houzhui[length-1]==='docx'){
        this.fileName = item;
        this.ifpdf = true;
      }else if(houzhui[length-1]==='jpg' ||houzhui[length-1]==='gif' || houzhui[length-1]==='png'){
        this.ifpdf = false;
        this.dialogImg =
                this.baseURLszwyweb +
                'FilePreview.svt/GetFileByName?token=' +
                this.token +
                '&fileName=' +
                item+
                '&uuid='+
                this.key;
    }
    },
    showFiles(item){
      this.dialogVisible = true;
      let idx;
      for (let i = 0; i < this.uploadData.length; i++) {
        if (item.Key === this.uploadData[i].DocumentValue) {
          idx = i;
          break;
        }
      }

      this.commonControllerSvr.FilePreview(this.token,this.uploadData[idx].AttachMentId).then(res=>{
          for(let key in res){
            this.key = key;
            this.files = res[key];
          }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.uploadForm {

    .content-wrapper {
      height: 500px !important;
      display: flex;
      justify-content: space-between;
      .el-dialog__body {
        height: 80%
      }
      .left-panel {
        width: 30%;
        border-right: 1px solid;
        margin-right: 20px;
      }
      .right-panel{
        width: 75%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

  .fileBox {
    width: 100%;
    height: 500px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .title {
    position: relative;
    flex: 1;
    font-size: 16px;
    line-height: 28px;
    min-width: 240px;
    font-weight: bold;
    padding: 10px 8px 10px 30px;
    background-color: #fff;
    color: #333;
    &::after {
      position: absolute;
      left: 20px;
      content: '';
      width: 4px;
      height: 16px;
      background: #0f77f2;
      top: 16px;
    }
  }
  .upload-table {
    width: 100%;
    box-sizing: border-box;
    background: #fcfcfc;
    border: 1px solid #cbd5e0;
    .fileItem {
      color: #0f77f2;
      cursor: pointer;
    }
    .row {
      display: flex;
      padding: 0;

      & > div {
        flex: 1;
        padding: 5px;
        border-left: 1px dotted #d4d4d4;
        border-bottom: 1px solid #d4d4d4;
        font-size: 14px;
        line-height: 28px;
        min-width: 80px;
        overflow: hidden;

        &.titleNumber {
          flex: 0 1 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
        }

        &.content {
          flex-grow: 1;
          min-width: 150px;
          overflow: hidden;
          margin: 0;
        }

        &.textarea {
          height: 110px;
          overflow-y: auto;
        }

        &.img {
          height: 180px;

          img {
            height: 170px;
          }
        }

        &.index {
          flex: 0 0 45px;
        }

        &:last-child {
          flex: 1;
        }
      }
    }
  }
}
</style>
